import { useEffect, useRef, useState } from 'react'

import { FACING_MODES } from '../components/shared/modal-upload-photo/modal-upload-photo.constants'

export const useUserMedia = ({ constraints, facingMode, onError }) => {
  const ref = useRef(null)
  const [isStreamEnabled, setIsStreamEnabled] = useState(false)

  useEffect(() => {
    const startStream = () => {
      const updatedConstraints = {
        ...constraints,
        video: {
          ...constraints.video,
          facingMode: facingMode || FACING_MODES.ENVIRONMENT,
        },
      }

      navigator?.mediaDevices
        ?.getUserMedia(updatedConstraints)
        .then((stream) => {
          setIsStreamEnabled(true)
          ref.current.srcObject = stream
        })
        .catch((err) => {
          onError(err)
        })
    }

    const currentRef = ref.current
    if (currentRef?.srcObject) {
      currentRef.srcObject.getTracks().forEach((track) => track.stop())
    }

    startStream()

    return () => {
      if (currentRef?.srcObject) {
        currentRef.srcObject.getTracks().forEach((track) => track.stop())
      }
    }
  }, [constraints, facingMode, onError])

  return { isStreamEnabled, ref }
}
